import React from 'react';
import config from '@config/config';

import { styled } from '@modules/common/components/ThemeProvider/utils';

const ContentContainer = (props: any) => {
  const HeaderComponent = props.component || 'h4';
  return (
    <StyledContentContainer {...props}>
      {props.header && (
        <HeaderComponent className="content-container-header">{props.header}</HeaderComponent>
      )}
      {props.children}
    </StyledContentContainer>
  );
};

const StyledContentContainer = styled('div')`
  background-color: ${config.backgroundGrey};

  .content-container-header {
    background-color: ${config.darkBackgroundGrey};
    padding: 1rem;
    margin: 0;
  }

  .content {
    padding: 1rem;
  }

  .primary-table * {
    border: none !important;
  }
`;

export default ContentContainer;
